<template>
  <div>
    <ContenedorCollapsable
      idCollapsable="empleabilidad"
      tituloColapsable="¿Cuál es la empleabilidad y el ingreso promedio bruto?"
    >
      <div class="kpis col-12 col-md-10 mx-md-auto mt-3 border-bottom-azul">
        <h3 class="subtt text-azul-medio w-100 text-center mt-3 mb-2">
          Empleabilidad
        </h3>

        <div class="d-md-flex">
          <div class="col-md-5 d-flex d-md-block sel1">
            <div class="row w-100 offset-md-1 d-inline-flex">
              <h6 class="col-1 d-md-none text-azul-medio text-nowrap">1:</h6>
              <ul
                class="col-10 col-md-12 w-100 ml-auto mx-md-0 mt-md-2 mb-0 px-0"
              >
                <li>
                  <dt class="label col">1º año:</dt>
                  <dd :class="reducirPadding(carrera1.empleabilidadPrimerAnio)">
                    {{ validarEmpleabilidad(carrera1.empleabilidadPrimerAnio) }}
                  </dd>
                </li>
                <li>
                  <dt class="label col">2º año:</dt>
                  <dd
                    :class="reducirPadding(carrera1.empleabilidadSegundoAnio)"
                  >
                    {{
                      validarEmpleabilidad(carrera1.empleabilidadSegundoAnio)
                    }}
                  </dd>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-md-2 icos text-center px-2">
            <img
              class="small-ic align-self-center"
              src="@/assets/img/iconos/comparador-1.svg"
              alt="maletín"
            />
          </div>
          <hr class="mt-0 d-block d-md-none" />

          <div class="col-md-5 d-flex d-md-block sel2">
            <div class="row w-100 offset-md-1 d-inline-flex">
              <h6 class="col-1 d-md-none text-azul-medio text-nowrap">2:</h6>
              <ul
                class="col-10 col-md-12 w-100 ml-auto mx-md-0 mt-md-2 mb-0 px-0"
              >
                <li>
                  <dt class="label col">1º año:</dt>
                  <dd :class="reducirPadding(carrera2.empleabilidadPrimerAnio)">
                    {{ validarEmpleabilidad(carrera2.empleabilidadPrimerAnio) }}
                  </dd>
                </li>
                <li>
                  <dt class="label col">2º año:</dt>
                  <dd
                    :class="reducirPadding(carrera2.empleabilidadSegundoAnio)"
                  >
                    {{
                      validarEmpleabilidad(carrera2.empleabilidadSegundoAnio)
                    }}
                  </dd>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="kpis col-12 col-md-10 mx-md-auto my-3 px-0 px-md-3">
        <h3 class="subtt text-azul-medio w-100 text-center mt-3 mb-2">
          ingreso promedio
        </h3>

        <div class="d-md-flex">
          <div class="col-md-5 d-flex d-md-block sel1">
            <div class="row w-100 offset-md-1 d-inline-flex">
              <h6 class="d-block d-md-none">{{ carrera1.carreraGenerica }}</h6>
              <ul
                class="col-10 col-md-12 w-100 ml-auto mx-md-0 mt-md-2 mb-0 px-0"
              >
                <li>
                  <dt class="label col">1º año:</dt>
                  <dd
                    :class="reducirPadding(carrera1.ingresoPromedioPrimerAnio)"
                  >
                    {{ validarIngreso(carrera1.ingresoPromedioPrimerAnio) }}
                  </dd>
                </li>
                <li>
                  <dt class="label col">2º año:</dt>
                  <dd
                    :class="reducirPadding(carrera1.ingresoPromedioSegundoAnio)"
                  >
                    {{ validarIngreso(carrera1.ingresoPromedioSegundoAnio) }}
                  </dd>
                </li>
                <li>
                  <dt class="label col">3º año:</dt>
                  <dd
                    :class="reducirPadding(carrera1.ingresoPromedioTercerAnio)"
                  >
                    {{ validarIngreso(carrera1.ingresoPromedioTercerAnio) }}
                  </dd>
                </li>
                <li>
                  <dt class="label col">4º año:</dt>
                  <dd
                    :class="reducirPadding(carrera1.ingresoPromedioCuartoAnio)"
                  >
                    {{ validarIngreso(carrera1.ingresoPromedioCuartoAnio) }}
                  </dd>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-md-2 icos text-center px-2">
            <img
              class="small-ic align-self-center"
              src="@/assets/img/iconos/comparador-2.svg"
              alt="alcancía"
            />
          </div>
          <hr class="mt-0 d-block d-md-none" />

          <div class="col-md-5 sel2">
            <div class="row w-100 offset-md-1 d-inline-flex">
              <h6 class="d-block d-md-none">
                {{ carrera2.carreraGenerica }}
              </h6>
              <ul
                class="col-10 col-md-12 w-100 ml-auto mx-md-0 mt-md-2 mb-0 px-0"
              >
                <li>
                  <dt class="label col">1º año:</dt>
                  <dd
                    :class="reducirPadding(carrera2.ingresoPromedioPrimerAnio)"
                  >
                    {{ validarIngreso(carrera2.ingresoPromedioPrimerAnio) }}
                  </dd>
                </li>
                <li>
                  <dt class="label col">2º año:</dt>
                  <dd
                    :class="reducirPadding(carrera2.ingresoPromedioSegundoAnio)"
                  >
                    {{ validarIngreso(carrera2.ingresoPromedioSegundoAnio) }}
                  </dd>
                </li>
                <li>
                  <dt class="label col">3º año:</dt>
                  <dd
                    :class="reducirPadding(carrera2.ingresoPromedioTercerAnio)"
                  >
                    {{ validarIngreso(carrera2.ingresoPromedioTercerAnio) }}
                  </dd>
                </li>
                <li>
                  <dt class="label col">4º año:</dt>
                  <dd
                    :class="reducirPadding(carrera2.ingresoPromedioCuartoAnio)"
                  >
                    {{ validarIngreso(carrera2.ingresoPromedioCuartoAnio) }}
                  </dd>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </ContenedorCollapsable>
  </div>
</template>

<script>
import ContenedorCollapsable from "@/components/comparadorITP/ContenedorCollapsable";
import FormatoMonetario from "@/utils/FormatoMonetario.js";

export default {
  name: "EmpleabilidadIngresoCollapse",
  components: {
    ContenedorCollapsable
  },
  props: {
    carrera1: { type: Object },
    carrera2: { type: Object }
  },
  methods: {
    validarIngreso(valor) {
      return valor != 0
        ? this.formatoMoneda(valor)
        : "SIN INFORMACIÓN DISPONIBLE";
    },
    validarEmpleabilidad(valor) {
      return valor != 0 ? `${valor} %` : "SIN INFORMACIÓN DISPONIBLE";
    },
    reducirPadding(valor) {
      return valor != 0 ? "cont col" : "cont";
    },
    formatoMoneda(value) {
      return FormatoMonetario.getMontoEnMoneda(value);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/comparadorITP/EmpleabilidadIngresoCollapse.vue